import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeasurementParseErrorGroupsListComponent } from 'src/app/public-utility/measurement-parse-errors/components/measurement-parse-error-list/measurement-parse-error-groups-list.component';
import { FlexModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { RouterModule } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [MeasurementParseErrorGroupsListComponent],
  imports: [
    CommonModule,
    FlexModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    RouterModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class MeasurementParseErrorListModule {}
